import React from "react";
import styled from "styled-components";
import settings from "../../../settings";
import { down } from "styled-breakpoints";

export const Frame = styled.a`
	display: flex;
	align-items: flex-end;
	cursor: pointer;
`;

export const Heading = styled.h5`
	font-weight: 700;
	font-family: "Montserrat", serif;
	color: ${settings.color.accent};
	font-size: 17.88px;
	letter-spacing: 3.22px;
	line-height: 1;
	margin-left: 2rem;
	${down("md")} {
		margin-left: 1rem;
	}
`;
